/**
 * OPBridge WS subprotocol constant.
 *
 * Was also home to `OPBRIDGE_MODE`/`resolveOpbridgeConfig` — the dual-mode
 * switch a Phase-1 spike used to pick between the legacy OPButtonsBridge
 * daemon (default) and OPBridge (opt-in via `VITE_BRIDGE_TARGET=opbridge`).
 * Removed 2026-08-20 with the legacy bridge itself (`packages/bridge/`,
 * `bridge/client.ts`) — dead code once there was only one daemon to talk
 * to. Moved from `bridge/` to `opbridge/` the same session: its only two
 * real consumers (`consumerWs.ts`, `trafficMonitor.ts`) already lived here.
 */

/** Subprotocol name OPBridge expects in the handshake. Token follows as a
 *  sibling entry: `['opbridge.v1', '<opb_token>']`. */
export const OPBRIDGE_SUBPROTOCOL = 'opbridge.v1';
